import { useEffect } from 'react'
import { SECONDARY_VIEW_KEYS } from '@/config/navigation/secondaryNav'
import PATHS from '@/routes/paths'

/** @param {object} m */
export function useBoardsAllRouteRedirect(m) {
  const { activePrimaryKey, homeView, threadMatch, navigate } = m
  useEffect(() => {
    if (activePrimaryKey !== 'home') return
    if (homeView === SECONDARY_VIEW_KEYS.HOME_BOARDS_ALL && threadMatch) {
      navigate(PATHS.HOME, { replace: true })
    }
  }, [activePrimaryKey, homeView, threadMatch, navigate])
}
